

















import Vue from 'vue';

type Role =
  | 'admin'
  | 'auditor'
  | 'cse'
  | 'gate.keeper'
  | 'reviewer'
  | 'task.master';

export default Vue.extend({
  props: {
    value: Array as () => Role[],
  },

  methods: {
    handleChange(val: string[]) {
      this.$emit('change', val);
    },
  },
});
